export default __webpack_public_path__ + "static/media/wp4.c11844a7.jpeg";